var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4276 4.05219L19.9184 7.50983M1 23L1.05856 22.5939C1.2658 21.1571 1.36943 20.4387 1.60513 19.7679C1.81428 19.1727 2.09999 18.6067 2.45523 18.084C2.85555 17.4948 3.37365 16.9816 4.40984 15.9553L18.786 1.7161C19.7501 0.7613 21.313 0.7613 22.2771 1.7161C23.241 2.6709 23.241 4.21894 22.2771 5.17374L7.63697 19.6742C6.69692 20.6053 6.22691 21.0708 5.69154 21.441C5.21633 21.7696 4.70382 22.0418 4.16453 22.2521C3.55696 22.489 2.90533 22.6192 1.60222 22.8796L1 23Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.c741499dcd8542b78295025475c9cf36.svg";
export { ForwardRef as ReactComponent };